import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  requiredValidator,
  reqValGreterThanNumber0,
} from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import {
  createWhatsappAutoTrigger,
  getWhatsappAutoTriggerByID,
  updateWhatsappAutoTrigger,
} from "./services/whatsappAutoTrigger.services";
import { clearWhatsappAutoTriggerDetails } from "./whatsappAutoTriggerSlice";
import {
  TRIGGERMODULE,
  TRIGGEROPERATION,
  TRIGGERWATO,
} from "../../_contstants/common";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { getAllActiveTemplates } from "../template/services/template.services";
import { ITemplate } from "../template/templateModel";
import { Label } from "@progress/kendo-react-labels";

const CreateWhatsappAutoTrigger: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const WhatsappAutoTriggerID = location.state?.WhatsappAutoTriggerID;
  const loading = useAppSelector((state) => state.whatsappAutoTrigger.loading);
  const WhatsappAutoTriggerDetail = useAppSelector(
    (state) => state.whatsappAutoTrigger.WhatsappAutoTriggerDetail
  );
  const TemplateList = useAppSelector((state) => state.template.TemplateList);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [WhatsappAutoTriggerDetail]);

  useEffect(() => {
    dispatch(getAllActiveTemplates());
    return () => {
      dispatch(clearWhatsappAutoTriggerDetails());
    };
  }, []);
  useEffect(() => {
    if (WhatsappAutoTriggerID) {
      dispatch(getWhatsappAutoTriggerByID(WhatsappAutoTriggerID));
    }
  }, [WhatsappAutoTriggerID]);

  const handleSubmit = async (values: any) => {
    try {
      if (WhatsappAutoTriggerID) {
        const editPayload = {
          ID: WhatsappAutoTriggerID,
          TriggerName: values?.TriggerName ? values?.TriggerName : "",
          Module: values?.Module ? values?.Module : "",
          Operation: values?.Operation ? values?.Operation : "",
          Whats_App_To: values?.Whats_App_To ? values?.Whats_App_To : "",
          DelayDay: values?.DelayDay ? +values?.DelayDay : null,
          DelayHour: values?.DelayHour ? +values?.DelayHour : null,
          DelayTime: values?.DelayTime ? +values?.DelayTime : null,
          TriggerTemplateID: values?.TriggerTemplateID
            ? +values?.TriggerTemplateID
            : null,
        };
        const response = await dispatch(updateWhatsappAutoTrigger(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate(-1);
        }
      } else {
        const insertPayload = {
          TriggerName: values?.TriggerName ? values?.TriggerName : "",
          Module: values?.Module ? values?.Module : "",
          Operation: values?.Operation ? values?.Operation : "",
          Whats_App_To: values?.Whats_App_To ? values?.Whats_App_To : "",
          DelayDay: values?.DelayDay ? +values?.DelayDay : null,
          DelayHour: values?.DelayHour ? +values?.DelayHour : null,
          DelayTime: values?.DelayTime ? +values?.DelayTime : null,
          TriggerTemplateID: values?.TriggerTemplateID
            ? +values?.TriggerTemplateID
            : null,
        };
        const response = await dispatch(
          createWhatsappAutoTrigger(insertPayload)
        );
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/autotrigger/whatsapp");
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={WhatsappAutoTriggerDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <ShadowCard style={{ padding: 12 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 5, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4>
                      {WhatsappAutoTriggerID
                        ? "Update WhatsApp Automation Trigger"
                        : "Add WhatsApp Automation Trigger"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="TriggerName"
                      label="Trigger Name"
                      placeholder="Trigger Name"
                      component={FormTextField}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"Module"}
                      name={"Module"}
                      label={"Module"}
                      placeholder="i.e. Lead"
                      astrike={true}
                      validator={requiredValidator}
                      component={FormSelectionField}
                      options={TRIGGERMODULE?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"Operation"}
                      name={"Operation"}
                      label={"Operation"}
                      placeholder="i.e. Inserted"
                      astrike={true}
                      validator={requiredValidator}
                      component={FormSelectionField}
                      options={TRIGGEROPERATION?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"Whats_App_To"}
                      name={"Whats_App_To"}
                      label={"WhatsApp To"}
                      placeholder="i.e. Lead"
                      astrike={true}
                      validator={requiredValidator}
                      component={FormSelectionField}
                      options={TRIGGERWATO?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Label style={{ marginTop: 14 }}>Delay By Day & Time</Label>
                    <div className="d-flex gap-2">
                      <Field
                        wrapperClassName="w-100 m-0"
                        name="DelayDay"
                        label=""
                        placeholder="Day"
                        min={0}
                        format="n0"
                        component={FormNumericTextField}
                        validator={reqValGreterThanNumber0}
                      />
                      <Field
                        wrapperClassName="w-100 m-0"
                        fieldClassName="no-spinner"
                        name="DelayHour"
                        label=""
                        placeholder="HH"
                        type="number"
                        minNumber="0"
                        maxNumber="23"
                        component={FormTextField}
                        validator={requiredValidator}
                      />
                      <span style={{ marginTop: 5 }}>:</span>
                      <Field
                        wrapperClassName="w-100 m-0"
                        fieldClassName="no-spinner"
                        name="DelayTime"
                        label=""
                        placeholder="MM"
                        type="number"
                        minNumber="0"
                        maxNumber="59"
                        component={FormTextField}
                        validator={requiredValidator}
                      />
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"TriggerTemplateID"}
                      name={"TriggerTemplateID"}
                      label={"Trigger Template"}
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      placeholder="Trigger Template"
                      options={TemplateList?.map((template: ITemplate) => {
                        return {
                          value: template?.ID,
                          label: template?.TemplateName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    style={{
                      marginTop: 20,
                      textAlign: "end",
                    }}
                  >
                    <div>
                      <ButtonWithLoading
                        label={WhatsappAutoTriggerID ? "Update" : "Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/autotrigger/whatsapp")}
                      >
                        Cancel
                      </Button>
                    </div>
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateWhatsappAutoTrigger;
